import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/idnp-automations/playbooks/$id/runs')({
  validateSearch: (search: Record<string, unknown>) => ({ playbookName: search.playbookName as string | undefined }),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.GartnerDemo];
    context.validatePermissions({ isAllowed, preload });
  },
});
